import events from 'email-management-lib/events.yaml';
import { useCallback, useMemo } from 'react';
export default function useTracking({
  tracker
}) {
  const usageTracker = useMemo(() => tracker.clone({
    preserveTrackerEvents: false,
    preserveTrackerProperties: false,
    trackerName: 'email-management',
    events
  }), [tracker]);
  const trackDashboardInteraction = useCallback(properties => {
    usageTracker.track('dashboardInteraction', Object.assign({}, properties));
  }, [usageTracker]);
  return {
    trackDashboardInteraction
  };
}